module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-guide-box"
  }, [_c('span', {
    staticClass: "login-text"
  }, [_vm._v("若您已有简历，可直接登录")]), _vm._v(" "), _c('a', {
    staticClass: "login-btn",
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-748bff14","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/loginGuide/index.vue
// module id = 364
// module chunks = 0